import Config from 'config';
import { call, put, select } from 'redux-saga/effects';

import { ON_EVENTS_MOUNT_ERROR } from '../actions';
import { getUserId } from '../../session/getters';
import waitForSession from '../../../lib/wait-for-session';

export function* onEventsMount() {
  yield call(waitForSession);

  try {
    const userId = yield select(getUserId);

    if (!userId) {
      throw new Error('No user - aborting');
    }
  }
  catch (e) {
    console.log(e);
    yield put({ type: ON_EVENTS_MOUNT_ERROR });
  }
}

export function* redirectToHomepage() {
  window.location.href = `${Config.api.host}`;
  return false;
}



// WEBPACK FOOTER //
// ./src/modules/my-events/actions/sagas.js